// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles_popup___w2WU"};